<script>
  module.exports = {
    name: 'ZkMenuItemGroup',

    componentName: 'ZkMenuItemGroup',

    props: {
      title: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        paddingLeft: 20
      };
    },
    methods: {
      initPadding() {
        var parent = this.$parent;
        var level = 0;
        var component = parent.$options.componentName;

        while (component !== 'ZkMenu') {
          if (component === 'ZkSubmenu') {
            level++;
          }
          parent = parent.$parent;
          component = parent.$options.componentName;
        }
        this.paddingLeft += level * 10;
      }
    },
    mounted() {
      this.initPadding();
    }
  };
</script>

<template>
  <li class="zk-menu-item-group">
    <div class="zk-menu-item-group__title" :style="{'padding-left': paddingLeft + 'px'}">{{title}}</div>
    <ul>
      <slot></slot>
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// menu-item-group.vue?145907ea